<ui-title [title]="'Audit log Report'">
</ui-title>

<div class="card">
	<div class="card-body">
		<form>
			<div class="form-group row">
				<label class="col-lg-1 col-form-label">
					Date From
				</label>
				<div class="col-lg-10">

					<div class="btn btn-primary float-left" (click)="helper_dateRemoveOneDay('dateFrom')">&lt;</div>
					<input class="form-control" style="width:200px;float:left" type="date" name="dateFrom"
						   [(ngModel)]="logs.data.dateFrom">
					<div class="btn btn-primary float-left" (click)="helper_dateAddOneDay('dateFrom')">&gt;</div>


				</div>
			</div>
			<div class="form-group row">
				<label class="col-lg-1 col-form-label">
					Date To
				</label>
				<div class="col-lg-10">
					<div class="btn btn-primary float-left" (click)="helper_dateRemoveOneDay('dateTo')">&lt;</div>
					<input class="form-control float-left" style="width:200px;float:left" type="date" name="dateTo"
						   [(ngModel)]="logs.data.dateTo">
					<div class="btn btn-primary float-left" (click)="helper_dateAddOneDay('dateTo')">&gt;</div>
				</div>
			</div>

			<button class="btn btn-primary" (click)="search()">
				Search
			</button>
		</form>
	</div>
</div>

<div class="col-lg-12 mt-4">
	<ui-loading [loadingText]="'loading report'" [loading]="logs.loading"></ui-loading>


	<ui-table #tableReportRows [chunker]="logs.chunker" (chunked)="logs.chunkedData = $event"
			  [headers]="logs.tableHeaders" [filters]="true">
		<tr *ngFor="let d of logs.chunkedData">
			<td>{{ d.Id }}</td>
			<td>{{ d.Path }}</td>
			<td>{{ d.Log }}</td>
			<td style="width:100px">{{ helper_idFunctionHasError(d) }}</td>
			<td>{{ d.CreatedDate|date }}</td>
			<td>

				<button class="btn btn-primary btn-sm" (click)="newJson_open(d.Json)"
					*ngIf="d.Json && d.Json!='{}'">json</button>

				<ui-modal [(isHidden)]="newJson.modalHidden" [lg]="true">
					<div>
						<pre [innerHTML]="helper_beautifyJson(selected_JsonData)"></pre>
					</div>
				</ui-modal>
				&nbsp;&nbsp;
				<button class="btn btn-primary btn-sm" (click)="newsoruserchanges_open(d.UserAuditLogs)"
						*ngIf="d.UserAuditLogs.length>0">Changes
				</button>
				<ui-modal [(isHidden)]="this.newsoruserchanges.modalHidden" [lg]="true">
					<div>
						<table class="table ">
							<thead>
							<tr>
								<th>Field</th>
								<th>User ID</th>
								<th>Date</th>
								<th>Old Value</th>
								<th>New Value</th>
							</tr>
							</thead>
							<tbody>
							<tr *ngFor="let record of selected_sor_user_changes">
								<td>{{ record.Field }}</td>
								<td>{{ record.UserId }}</td>
								<td>{{ record.CreatedDate | date:'short' }}</td>
								<td>{{ record.OldValue }}</td>
								<td>{{ record.NewValue }}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</ui-modal>
			</td>

		</tr>
	</ui-table>

</div>
